import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import SEO from '../../../seo';

const TermsRead = ({ term, colorId, onClose }) => {
    const { t } = useTranslation();

    // Блокируем скролл основной страницы
    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, []);

    if (!term) return null;

    // Берем первую букву для красивого хедера
    const firstLetter = term.content.termName ? term.content.termName.charAt(0).toUpperCase() : '?';

    return (
        // Используем те же классы модалки из _formulas_read.scss
        <div className="read_term_back_overlay" onClick={onClose}>

            <SEO>
                {/* Формат: Физика: Название формулы */}
                <title>{`${t('translate.app_name2')}: ${term.content.termName}`}</title>
            </SEO>

            <div className="term-krasivo-modal" onClick={(e) => e.stopPropagation()}>

                <button className="term-krasivo-modal__close" onClick={onClose}>×</button>

                <div className="term-krasivo-modal__content">

                    {/* ВЕРХНИЙ БЛОК НА ЦВЕТНОМ ФОНЕ (Вместо формулы - гигантская буква) */}
                    <div className={`term-krasivo-modal__latex-viewww term-krasivo-modal__latex-viewww--${colorId || 0}`}>
                        <span style={{ fontSize: '80px', fontWeight: 'bold', opacity: 0.9 }}>
                            {firstLetter}
                        </span>
                    </div>

                    <h2 className="term-krasivo-modal__zagolovok">{term.content.termName}</h2>

                    {/* Описание термина */}
                    <p className="term-krasivo-modal__description" style={{ fontSize: '17px' }}>
                        {term.content.termDescription}
                    </p>

                </div>
            </div>
        </div>
    );
};

export default TermsRead;